import { defineComponent as l, createBlock as r, openBlock as n, unref as m, mergeProps as c, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const d = /* @__PURE__ */ l({
  name: "IconBackMarketPromise",
  __name: "IconBackMarketPromise",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (i, a) => (n(), r(m(s), c(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("path", { d: "M19.503 5.686 12 3.502 4.497 5.687V9.49c0 4.162 2.417 7.99 7.503 11.004 5.087-3.013 7.503-6.838 7.503-11.004V5.686m1.488 4.257c-.173 4.673-3.018 8.764-8.258 11.859a1.438 1.438 0 0 1-.733.2l-.19-.013a1.432 1.432 0 0 1-.543-.187c-5.238-3.097-8.085-7.19-8.258-11.86L3 9.49V5.651a1.459 1.459 0 0 1 .93-1.355l.114-.038 7.553-2.2a1.458 1.458 0 0 1 .808 0l7.554 2.2h-.003A1.46 1.46 0 0 1 21 5.65v3.84l-.009.454" }, null, -1),
        e("path", { d: "m10.235 7.636-3.192 3.198a.1.1 0 0 0 0 .142l3.263 3.269h2.093a.061.061 0 0 0 .043-.104l-3.158-3.165a.1.1 0 0 1 0-.142l3.262-3.27h-2.141a.24.24 0 0 0-.17.072" }, null, -1),
        e("path", { d: "m11.224 10.978 3.262 3.268h2.094a.061.061 0 0 0 .043-.104l-3.23-3.235 3.334-3.34h-2.142a.24.24 0 0 0-.17.07l-3.191 3.198a.1.1 0 0 0 0 .143" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
